var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6986 11.8438L10.1286 7.2992C10.2065 7.21937 10.25 7.11231 10.25 7.00084C10.25 6.88937 10.2065 6.78231 10.1286 6.70249L5.6986 2.15617C5.66236 2.11895 5.61902 2.08936 5.57116 2.06916C5.52329 2.04896 5.47186 2.03855 5.41991 2.03855C5.36795 2.03855 5.31652 2.04896 5.26866 2.06916C5.22079 2.08936 5.17746 2.11895 5.14121 2.15617C5.06665 2.23251 5.0249 2.33499 5.0249 2.44171C5.0249 2.54842 5.06665 2.6509 5.14121 2.72724L9.3071 7.00084L5.14121 11.2736C5.0669 11.3499 5.02532 11.4522 5.02532 11.5587C5.02532 11.6652 5.0669 11.7675 5.14121 11.8438C5.17746 11.881 5.22079 11.9106 5.26866 11.9308C5.31652 11.951 5.36795 11.9614 5.41991 11.9614C5.47186 11.9614 5.52329 11.951 5.57116 11.9308C5.61902 11.9106 5.66236 11.881 5.6986 11.8438Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.a39ddf110a5f32332db114ccbc98cb00.svg";
export { ForwardRef as ReactComponent };